import React from 'react';
import styled from 'styled-components'
//import { ReactComponent as Header } from './../../Resources/AppScreens/CommonComponents/Advocacy/Navigation.svg';
import _Header from './../../Resources/AppScreens/CommonComponents/Advocacy/Navigation.svg';
import Custom0 from './../../Resources/AppScreens/CommonComponents/Advocacy/Learn More.svg';

import Custom1 from './../../Resources/AppScreens/CommonComponents/Advocacy/Two Buttons.svg';
import Custom2 from './../../Resources/AppScreens/CommonComponents/Advocacy/Donate.svg';
import _Custom3 from './../../Resources/AppScreens/CommonComponents/Advocacy/Social Links.svg';
//import { ReactComponent as Custom4 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Property Resources.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Advocacy/Bottom Navigation.svg';
import AdvocacyComponents from './../../Resources/AppScreens/Preview-Features/Advocacy';
import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 6px;
    padding: 0;
    &>* {
        margin: 5px 12px 0 12px;
    }
    @media (min-width: 768px) and (max-width: 1025px) {
        width: 100%;
        padding: 0;
        &>* {
            margin: 5px 8px 0 8px;
        }
    }
`;

const Custom3 = styled.img.attrs({src: _Custom3})`
    width: 250px;
    margin: 0;
    @media (min-width: 768px) and (max-width: 1025px) {
        width: 100%;
        margin: 0;
    }
`;

const AdvocacyPreview = ({ features }) => (<Container>
    <img src={_Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src={Custom0} />
        <img src={Custom1} style={{marginTop: "4px"}} />
        <img src={Custom2} />
        {(!features || features.length === 0) && <Custom3/>}
        {features && features.map(feature => AdvocacyComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default AdvocacyPreview;

